<template>
  <div id="app">    
    <div class="map-holder">
      <GoogleMap
        :api-key="API_KEY"
        :center="MAP_CENTER"
        :zoom="5">
         <MarkerCluster>
          <Marker v-for="(location, i) in locations" :options="{ position: location }" :key="i" />
        </MarkerCluster>
      </GoogleMap>
    </div>
    <div class="stats-holder">
      <div>
        <h1 @click="toggleFullscreen()">SoftPOS <span class="counter">{{ api.countDown }}</span></h1>
        <h3>{{ startDateLabel }} - {{ currentDateLabel }}</h3>
      </div>
      <div class="space">
        <div>
          <table>
            <tbody>
              <tr>
                <td colspan="3">
                  <div class="space"></div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <h2>Total</h2>
                </td>
              </tr>
              <tr>
                <td>Paid</td>
                <td class="text-right"><NumberView :value="quantityTotal()" /> st</td>
                <td class="text-right"><NumberView :value="amountTotal()" /> kr</td>
              </tr>
              <tr>
                <td>Merchants</td>
                <td class="text-right"><NumberView :value="merchantQuantityTotal()" /> st</td>
                <td class="text-right"><NumberView :value="merchantAverageAmount()" /> kr</td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="space"></div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <h2>Payment</h2>
                </td>
              </tr>
              <tr v-for="paymentMethod in paymentMethods" :key="paymentMethod">
                <td>{{ paymentMethod }}</td>
                <td class="text-right"><NumberView :value="quantityByPaymentMethod(paymentMethod)" /> st</td>
                <td class="text-right"><NumberView :value="amountByPaymentMethod(paymentMethod)" /> kr</td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="space"></div>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <h2>Origin</h2>
                </td>
              </tr>
              <tr v-for="origin in origins" :key="origin">
                <td>{{ origin }}</td>
                <td class="text-right"><NumberView :value="quantityByOrigin(origin)" /> st</td>
                <td class="text-right"><NumberView :value="amountByOrigin(origin)" /> kr</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberView from './NumberView.vue';
import { GoogleMap, Marker, MarkerCluster } from 'vue3-google-map';
import { ref } from 'vue';

export default {
  name: 'MapView',
  components: {
    NumberView,
    GoogleMap,
    Marker,
    MarkerCluster
  },
  data() {
    return {
      api: {
        since: null,
        countDownInterval: 60,
        countDown: 0,
      },
      sinceLocal: null,
      startDateLabel: '',
      currentDateLabel: '',
      origins: [],
      paymentMethods: [],
      dataAll: [],
      data: [],
      circles: {},
      locations: [],
      isFullscreen: false,
      midnightResetTimer: null,
      countDownTimerActive: true
    }
  },
  setup() {
    const API_KEY = "AIzaSyDiMT7HAw4MXCaYVF1ylTCcHGr8YOMvqHU"
    const MAP_CENTER = ref({ lat: 62.38583179, lng: 16.321998712 })
    return {
      API_KEY,
      MAP_CENTER
    };
  },
  computed: {
    activeOrders: function () {
      return this.data !== undefined && this.data.length > 0
        ? this.data.filter((order) => order.paymentStatus === 'Paid')
        : [/*{
          "timestamp": "",
          "merchantId": "",
          "locationId": "",
          "amount": 0,
          "latitude": 0,
          "longitude": 0,
          "origin": "",
          "paymentMethod": "",
          "paymentStatus": ""
        }*/]
    }
  },  
  methods: {
    countDownTimer () {
      if (!this.countDownTimerActive) return

      if (this.api.countDown > 0) {
        setTimeout(() => {
          this.api.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
      else {
        this.api.countDown = this.api.countDownInterval;
        this.loadFromApi()
        this.countDownTimer()
      }
      this.updateSummary()
    },
    loadFromApi () {
      if(this.api.since === null) {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        this.api.since = today
        this.startDateLabel = today.toLocaleDateString() + ' ' + today.toLocaleTimeString()
      }

      const sinceString = this.api.since.toISOString()
      const apiUrl = 'https://purspot-stats-trace-hufza0b8g7cmgqep.westeurope-01.azurewebsites.net/api/traces?key=8750d775-f26d-4eb3-9699-cef9dfb67a0b&since=' + encodeURIComponent(sinceString)

      const self = this
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => self.updateData(data))
        .catch(error => console.error('Error:', error));
    },
    updateData(data) {
      if(data != null && data.length > 0) {
        this.dataAll.push(...data)

        var lastTimestamp = new Date(data[0].timestamp)
        this.api.since = new Date(lastTimestamp.getTime() + 1)
      }
    },
    updateSummary () {
      this.sinceLocal = new Date(this.sinceLocal.getTime() + 1000)

      const now = new Date()
      this.currentDateLabel = now.toLocaleDateString() + ' ' + now.toLocaleTimeString()

      if(this.dataAll !== undefined && this.dataAll.length > 0) {
        
        const sinceLocalString = this.sinceLocal.toISOString()
        this.data = this.dataAll.filter((order) => order.timestamp <= sinceLocalString)

        const origins = [...new Set(this.data.map(item => item.origin))].sort();
        const paymentMethods = [...new Set(this.data.map(item => item.paymentMethod))].sort();
        
        this.origins = origins
        this.paymentMethods = paymentMethods

        this.circles = {}
        this.locations = []
        for (const i in this.data) {
          if(i > 1000)
            return

          this.locations.push({ lat: this.data[i].latitude, lng: this.data[i].longitude })
        }
      }
    },
    amountTotal: function() {
        return this.activeOrders.reduce((sum, obj) => { return sum + obj.amount; }, 0)
    },
    quantityTotal: function() {
      return this.activeOrders.length
    },
    merchantQuantityTotal: function() {
      return [...new Set(this.data.map(item => item.merchantId))].length;
    },
    merchantAverageAmount: function() {
      return this.amountTotal() > 0 ? this.amountTotal() / this.merchantQuantityTotal() : 0
    },
    amountByOrigin: function (originName) {
      return this.activeOrders
              .filter((order) => order.origin === originName)
              .reduce((sum, obj) => { return sum + obj.amount; }, 0)
    },
    quantityByOrigin: function (originName) {
      return this.activeOrders.filter((order) => order.origin === originName).length
    },
    amountByPaymentMethod: function (paymentMethodName) {
      return this.activeOrders
              .filter((order) => order.paymentMethod === paymentMethodName)
              .reduce((sum, obj) => { return sum + obj.amount; }, 0)
    },
    quantityByPaymentMethod: function (paymentMethodName) {
      return this.activeOrders.filter((order) => order.paymentMethod === paymentMethodName).length
    },
    toggleFullscreen: function() {
      if (!document.fullscreenElement) {
        document.body.requestFullscreen()
          .then(() => {
            this.isFullscreen = true
          })
      } else {
        document.exitFullscreen()
          .then(() => {
            this.isFullscreen = false
          })
      }
    },
    checkMidnightReset() {
      const now = new Date()
      const midnight = new Date(now)
      midnight.setHours(24, 0, 0, 0)

      const msUntilMidnight = midnight - now

      this.midnightResetTimer = setTimeout(() => {
        this.resetData()
        this.checkMidnightReset()
      }, msUntilMidnight)
    },
    resetData() {
      this.dataAll = []
      this.data = []
      this.locations = []
      this.origins = []
      this.paymentMethods = []

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      this.api.since = today

      this.sinceLocal = new Date(new Date().getTime() - (5 * 60000))
      this.startDateLabel = this.sinceLocal.toLocaleDateString() + ' ' + this.sinceLocal.toLocaleTimeString()

      this.loadFromApi()
    }
  },
  created () {
    this.sinceLocal = new Date(new Date().getTime() - (5 * 60000))
    this.startDateLabel = this.sinceLocal.toLocaleDateString() + ' ' + this.sinceLocal.toLocaleTimeString()

    this.countDownTimer()
    this.checkMidnightReset()
  },
  beforeUnmount () {
    this.countDownTimerActive = false
    if (this.midnightResetTimer) {
      clearTimeout(this.midnightResetTimer)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.counter {
  color: rgba(255,255,255,0.1);
  float: right;
}
</style>
